module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"links":{"general":"Verification","security":"Security","verification":"Verification"}},"zh":{"links":{"general":"一般的","security":"安全","verification":"帐户验证"}},"kr":{"links":{"general":"일반","security":"보안","verification":"확인"}}}')
  delete Component.options._Ctor
}
